export default __webpack_public_path__ + "static/media/asics-K.7883d24d.png";